import { useState } from 'react'
import { Button } from '@material-ui/core/'
import { withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import CustomModel from "Utills/Model/CustomModel"
import { Close } from "@material-ui/icons";
import { CustomRatings2 } from "Utills/CustomRatings"

//===================== THIS is a Post Review Modal / POPUP ========================

const PostReview = (props) => {
    //================= State for modal open & close ============================
    const [modalOpened, setModalOpened] = useState(true);
    const [formData, setFormData] = useState({
        communication: 3,
        overAll_behavior: 4,
        punctuality: 1,
        otherMessage: '',
    });

    //======================= Handle ratings stars ====================
    const handleRatings = (e) => {
        let { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: parseInt(value)
        })
    };
    // 
    return (
        <div className="header-spacer">
            <div className="container py-5">
                <div className="row py-5">
                    {/*========== check if user is logged IN  ==================*/}
                    {props?.current_user?.email ?
                        <div className="col-12 text-center">
                            <Button variant="contained" color="secondary" onClick={() => setModalOpened(true)}>Post a Review</Button>
                            <CustomModel openPopup={modalOpened} setOpenPopup={setModalOpened} >
                                <div className="review_modal">
                                    {/* header */}
                                    <div className="model-header bg-pr">
                                        <div className="filter-model-close-btn bg-white" onClick={() => setModalOpened(false)}>
                                            <Close className="text-dark" />
                                        </div>
                                        <h4 className="text-white">Rating</h4>
                                    </div>
                                    {props.current_user?.is_captain ?
                                        <CaptainReviewForm
                                        setModalOpened={setModalOpened}
                                        />
                                        :
                                        <>
                                            <div className="py-3 px-4">
                                                <h5 className="text-gr text-center">Add your review</h5>
                                                <hr className="mt-3 opacity-25 mx-5" />
                                                <div className="row mx-0 my-2 pt-md-3 mt-2">
                                                    <div className="col-md-6 col-12">
                                                        <p className="text-pr text-left fw-normal">Overall behavior</p>
                                                    </div>
                                                    <div className="col-md-6 text-right col-12">
                                                        <CustomRatings2 name="overAll_behavior"
                                                            value={formData?.overAll_behavior}
                                                            onChange={handleRatings} />
                                                    </div>
                                                </div>
                                                <div className="row mx-0 my-2">
                                                    <div className="col-md-6 col-12">
                                                        <p className="text-pr text-left fw-normal">Punctuality</p>
                                                    </div>
                                                    <div className="col-md-6 text-right col-12">
                                                        <CustomRatings2 name="punctuality"
                                                            value={formData?.punctuality}
                                                            onChange={handleRatings} />
                                                    </div>
                                                </div>
                                                <div className="row mx-0 my-2">
                                                    <div className="col-md-6 col-12">
                                                        <p className="text-pr text-left fw-normal">Communication</p>
                                                    </div>
                                                    <div className="col-md-6 text-right col-12">
                                                        <CustomRatings2
                                                            name="communication"
                                                            value={formData?.communication}
                                                            onChange={handleRatings}
                                                        />
                                                    </div>
                                                </div>
                                                <hr className="mt-3 mx-5" />
                                                <div className="w-100 px-2 text-left">
                                                    <h5>Describe your experience</h5>
                                                    <textarea placeholder="Describe here..." className="cs_textArea mt-3" name="otherMessage" onChange={(e) => setFormData({ ...formData, otherMessage: e.target.value?.trim() })} value={formData?.otherMessage} />
                                                    <div className="text-right text-pr">{formData?.otherMessage?.length || 0} /500</div>
                                                </div>
                                            </div>
                                            <div className="mt-2 px-4  pb-3 d-flex flex-wrap  justify-content-between align-center">
                                                <div className="col-sm-6 col-12 px-3 my-2">
                                                    <button className="text-dark fw-bold light-btn bg-more-light"
                                                        onClick={() => {
                                                            setModalOpened(false)
                                                            setFormData({
                                                                communication: 3,
                                                                overAll_behavior: 4,
                                                                punctuality: 1,
                                                                otherMessage: '',
                                                            })
                                                        }}
                                                    >Cancel</button>

                                                </div>
                                                <div className="col-sm-6 col-12 px-3 my-2">
                                                    <button className="text-white dark-btn" onClick={() => {
                                                        setModalOpened(false)
                                                        setFormData({
                                                            communication: 3,
                                                            overAll_behavior: 4,
                                                            punctuality: 1,
                                                            otherMessage: '',
                                                        })
                                                    }}>Add Review</button>
                                                </div>
                                            </div>
                                        </>}
                                </div>
                            </CustomModel>
                        </div>
                        :
                        <div className="col-12 text-center">
                            <h4 className="text-pr py-4">Not Logged In</h4>
                            <Button variant="contained" color="secondary" to="/" component={Link}>Visit Site</Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}


//===================== This Modal show when a logged in user is captain  ====================
const CaptainReviewForm = ({setModalOpened}) => {
    //====================== form states ========================
    const [formData, setFormData] = useState({
        general_condition: 3,
        equipments: 4,
        cleanLiness: 1,
        crew_behave: 5,
        overAll_behavior: 4,
        punctuality: 4,
        hospitality: 5,
        otherMessage: '',
    });

    // ================= handle ratings stars ===========================
    const handleRatings = (e) => {
        let { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: parseInt(value)
        })
    };

    
    return (
        <>
            <div className="py-3 px-4">
                <h5 className="text-gr text-center">Add your review</h5>
                <hr className="mt-3 opacity-25 mx-5" />
                <h5 className="w-100 text-left">Boat</h5>
                <div className="row mx-0 my-2 pt-md-3 mt-2">
                    <div className="col-md-6 col-12">
                        <p className="text-pr text-left fw-normal">General Condition</p>
                    </div>
                    <div className="col-md-6 text-right col-12">
                        <CustomRatings2 name="general_condition"
                            value={formData?.general_condition}
                            onChange={handleRatings} />
                    </div>
                </div>
                <div className="row mx-0 my-2">
                    <div className="col-md-6 col-12">
                        <p className="text-pr text-left fw-normal">Equipment</p>
                    </div>
                    <div className="col-md-6 text-right col-12">
                        <CustomRatings2 name="equipments"
                            value={formData?.equipments}
                            onChange={handleRatings} />
                    </div>
                </div>
                <div className="row mx-0 my-2">
                    <div className="col-md-6 col-12">
                        <p className="text-pr text-left fw-normal">Cleanliness</p>
                    </div>
                    <div className="col-md-6 text-right col-12">
                        <CustomRatings2
                            name="cleanLiness"
                            value={formData?.cleanLiness}
                            onChange={handleRatings}
                        />
                    </div>
                </div>
                <div className="row mx-0 my-2">
                    <div className="col-md-6 col-12">
                        <p className="text-pr text-left fw-normal">Crew Behavior</p>
                    </div>
                    <div className="col-md-6 text-right col-12">
                        <CustomRatings2
                            name="crew_behave"
                            value={formData?.crew_behave}
                            onChange={handleRatings}
                        />
                    </div>
                </div>
                <hr className="mt-3 opacity-25 mx-5" />
                <h5 className="w-100 text-left">Captain</h5>
                <div className="row mx-0 my-2 pt-md-3 mt-2">
                    <div className="col-md-6 col-12">
                        <p className="text-pr text-left fw-normal">Overall behavior</p>
                    </div>
                    <div className="col-md-6 text-right col-12">
                        <CustomRatings2 name="overAll_behavior"
                            value={formData?.overAll_behavior}
                            onChange={handleRatings} />
                    </div>
                </div>
                <div className="row mx-0 my-2">
                    <div className="col-md-6 col-12">
                        <p className="text-pr text-left fw-normal">Punctuality</p>
                    </div>
                    <div className="col-md-6 text-right col-12">
                        <CustomRatings2 name="punctuality"
                            value={formData?.punctuality}
                            onChange={handleRatings} />
                    </div>
                </div>
                <div className="row mx-0 my-2">
                    <div className="col-md-6 col-12">
                        <p className="text-pr text-left fw-normal">Hospitality</p>
                    </div>
                    <div className="col-md-6 text-right col-12">
                        <CustomRatings2
                            name="hospitality"
                            value={formData?.hospitality}
                            onChange={handleRatings}
                        />
                    </div>
                </div>
                <hr className="mt-3 mx-5" />
                <div className="w-100 px-2 text-left">
                    <h5>Describe your experience</h5>
                    <textarea placeholder="Describe here..." className="cs_textArea mt-3" name="otherMessage" onChange={(e) => setFormData({ ...formData, otherMessage: e.target.value?.trim() })} value={formData?.otherMessage} />
                    <div className="text-right text-pr">{formData?.otherMessage?.length || 0} /500</div>
                </div>
            </div>
            <div className="mt-2 px-4  pb-3 d-flex flex-wrap  justify-content-between align-center">
                <div className="col-sm-6 col-12 px-3 my-2">
                    <button className="text-dark fw-bold light-btn bg-more-light"
                        onClick={() => {
                            setModalOpened(false)
                            setFormData({
                                communication: 3,
                                overAll_behavior: 4,
                                punctuality: 1,
                                otherMessage: '',
                            })
                        }}
                    >Cancel</button>

                </div>
                <div className="col-sm-6 col-12 px-3 my-2">
                    <button className="text-white dark-btn" onClick={() => {
                        setModalOpened(false)
                        setFormData({
                            communication: 3,
                            overAll_behavior: 4,
                            punctuality: 1,
                            otherMessage: '',
                        })
                    }}>Add Review</button>
                </div>
            </div>
        </>
    )
};

// REDUX CONFIG 
const mapStateToProps = (state) => ({
    current_user: state.current_user
})

export default connect(mapStateToProps, null)(withRouter(PostReview))
